/**
 * Normalize an insurance member/policy ID for payer submission.
 *
 * Cards print member IDs in grouped form ("0223-61-43"; MBIs as
 * "1EG4-TE5-MK73") and staff key them in verbatim — but payers store and
 * match bare alphanumerics. CMS: "The dashes aren't used as part of the
 * MBI… they won't be entered into computer systems." BCBS MA companion
 * guide: "Member IDs should not contain hyphens, spaces, or any special
 * characters." No payer documents a separator as a meaningful ID character,
 * and Stedi forwards the field to the payer verbatim — so a formatted ID
 * passes every validation layer and then silently fails to match.
 *
 * Strips everything that isn't a letter or digit. Letters and digits pass
 * through untouched — case and leading zeros preserved, and dash-delimited
 * person-code suffixes keep their digits ("1234-0" → "12340", never "1234").
 *
 * Apply at the payer-submission boundary (Stedi request, RPA bot inputs) and
 * in the eligibility-set dedup key — never to stored records, which keep the
 * as-entered value so staff can eyeball it against the card.
 */
export function normalizeMemberId(raw: string | null | undefined): string {
  return (raw ?? '').replace(/[^A-Za-z0-9]/g, '')
}
